import dayjs, { Dayjs } from 'dayjs';
import { IAssemblySearch } from 'src/interfaces';

// This file may or may not be needed and can be removed after Slice 1
export const formatDateRange = (
  assembly?: IAssemblySearch,
  selectedStartDate?: Dayjs | null,
  selectedEndDate?: Dayjs | null,
) => {
  const endDateMax = assembly?.end_date
    ? dayjs(assembly?.end_date).subtract(1, 'day').valueOf()
    : null;

  return {
    startDateMax: selectedEndDate ?? endDateMax ? dayjs(endDateMax) : undefined,
    endDateMin: selectedStartDate ?? dayjs(),
    endDateMax: endDateMax ? dayjs(endDateMax) : undefined,
  };
};
